// GERADO por scripts/static-manifest.ts — não editar (§2.7.8). Caminhos com hash de conteúdo; null = estático
// ainda não gerado (o loadStatic trata como ausente).
export type StaticKey = 'geography' | 'candidates' | 'firstRound' | 'baseline2022' | 'geoUf' | 'geoMun' | 'geoWorld' | 'zonesIndex' | 'replayPhotos';
export type StaticManifest = Readonly<Record<StaticKey, string | null>>;

export const STATIC: StaticManifest = {
  geography:    '/static/geography.5d283b7173.json',
  candidates:   '/static/candidates.6f1a2ccc67.json',
  firstRound:   '/static/first-round.e812f0238e.json',
  baseline2022: '/static/baseline-2022.5203e141df.json',
  geoUf:        '/geo/br-uf.823952a088.topo.json',
  geoMun:       '/geo/br-mun.edccd64eb4.topo.json',
  geoWorld:     null,
  zonesIndex:   null,
  replayPhotos: '/static/replay-photos.b7819829c5.json',
};
